<template>
    <div class="mm-navigation"
        :class="{
            'mobile-menu-opened': openedMobileMenu,
            'mm-navigation--always-visible': alwaysTop,
        }">

        <nav class="mm-navigation-top">

            <!--
            @media (max-width: 991px)
            .vue-page .mobile-menu-opened .mm-navigation__menu {
                bottom: auto - vyzkouset jestli by to tak na mobilu nebylo lepsi
            }
            -->
            <!-- Prepinac Navigace -->
            <button @click="togleMobileMenu"
                :class="{
                    'active': openedMobileMenu && mobileContentWrapper === 'MobileMenu',
                }"
                type="button"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="mm-navigation__toggle-btn">
                <i class="icon icon-menu"></i>
            </button>

            <button @click="toggleAnonymousContent"
                :class="{
                    'active': openedMobileMenu && mobileContentWrapper === 'AnonymousContent',
                }"
                type="button"
                aria-expanded="false"
                aria-label="Toggle navigation"

                class="mm-navigation__toggle-btn">
                <i class="icon icon-user"></i>
            </button>

            <!-- NADPIS -->
            <router-link :to="localeRoute('home')"  class="mm-navigation__banner navbar-brand">
                <span class="mm-navigation__logo"><i class="icon-squares"></i></span>
                <span class="mm-navigation__title">
                    <span>
                        mapsfy.com
                    </span>
                </span>
            </router-link>

            <button
                @click="toggleAnonymousContent"
                type="button"
                aria-expanded="false"
                aria-label=""
                style="position: relative;"
                class="mm-navigation__toggle-btn">
                    <i :class="{
                        'mm-hp-icon-basket_empty': (basketItemsCount === null || basketItemsCount === 0),
                        'mm-hp-icon-basket_full':  !(basketItemsCount === null || basketItemsCount === 0),
                    }"></i>
                    <div v-if="basketItemsCount !== null"
                        class="mm-navigation__menu-item-counter">
                        {{basketItemsCount}}
                    </div>
            </button>

            <!-- Menu + Mobile Wrapper (Login, Profile,...) -->
            <div class="mm-navigation__menu">
                <ul :v-hide="mobileContentWrapper === 'AnonymousContent'"
                    :class="{
                        'd-none d-lg-flex': mobileContentWrapper === 'AnonymousContent',
                        'mm-navigation__menu-list--secondary-menu-on-hover': menuOnHover,
                        'mm-navigation__menu-list': true
                    }">

                    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover">
                        <router-link
                            :to="localeRoute('home')"
                            class="mm-navigation__menu-link nav-link">
                            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
                            <span class="mm-navigation__menu-list-item-label">
                                Domu
                            </span>
                        </router-link>
                    </li>

                    <NavigationSubmenuItem
                        :to="localeRoute('solutions')"
                        :label="'Rieseni'"
                        :submenuContentHeading="$t('solutions.name')"
                        :submenuContentDescription="$t('solutions.description')"
                        :items="$t('solutions.items')"
                        :mobileOnHover="true"
                    />

                    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover">
                        <router-link
                            :to="localeRoute('help')"
                            class="mm-navigation__menu-link nav-link"
                            active-class="mm-navigation__menu-link--active">
                            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
                            <span class="mm-navigation__menu-list-item-label">
                                Help
                            </span>
                        </router-link>
                    </li>

                    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover">
                        <router-link
                            :to="localeRoute('news')"
                            class="mm-navigation__menu-link nav-link"
                            active-class="mm-navigation__menu-link--active">
                            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
                            <span class="mm-navigation__menu-list-item-label">
                                Novinky
                            </span>
                        </router-link>
                    </li>

                    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover">
                        <router-link
                            :to="localeRoute('workshops')"
                            class="mm-navigation__menu-link nav-link"
                            active-class="mm-navigation__menu-link--active">
                            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
                            <span class="mm-navigation__menu-list-item-label">
                                WORKSHOPY
                            </span>
                        </router-link>
                    </li>

                    <li class="mm-navigation__menu-list-item mm-navigation__menu-list-item mm-navigation__menu-list-item--with-hover">
                        <a
                            href="https://omdevapi.emis-online.sk/"
                            class="mm-navigation__menu-link nav-link"
                            active-class="mm-navigation__menu-link--active">
                            <i class="icon icon-info-circle mm-navigation__menu-list-item-icon"></i>
                            <span class="mm-navigation__menu-list-item-label">
                                E-shop s priestorovými dátami
                            </span>
                        </a>
                    </li>

                    <Switcher />

                    <li style="position: relative"
                        :class="[
                            'd-none',
                            'd-lg-block',
                            'mm-navigation__menu-list-item',
                            'mm-navigation__menu-list-item--out-of-list',
                            'mm-navigation__menu-list-item--only-icon',
                            'mm-navigation__menu-list-item--with-hover',
                            'mm-navigation__menu-list-item--bordered'
                        ]">
                            <a class="mm-navigation__menu-link" title="basket">
                                <div class="mm-navigation__menu-list-item-container">
                                    <i class="mm-navigation__menu-list-item-icon"
                                        :class="{
                                            'mm-hp-icon-basket_empty': (basketItemsCount === null || basketItemsCount === 0),
                                            'mm-hp-icon-basket_full':  !(basketItemsCount === null || basketItemsCount === 0),
                                        }">
                                    </i>
                                    <div v-if="basketItemsCount !== null"
                                        class="mm-navigation__menu-item-counter">
                                        {{basketItemsCount}}
                                    </div>
                                </div>
                            </a>

                    </li>

                </ul>

                <div v-if="mobileContentWrapper === 'AnonymousContent'" class="mm-navigation__menu-content" style="width: 100%">
                    <AnonymousContent
                        v-if="!authenticated"
                        :showCloseIcon="false"/>
                    <ProfileContent
                        v-else />
                </div>
            </div>



            <!-- Dropdown pouze na velkych displejich -->
            <NavigationDropdown
                v-if="!authenticated"
                class="d-none d-lg-block"
                :closeContentClick="false"
                :isBordered="true"
                :isOutOfList="true"
                :vIfSlot="true"
                :outerState="{
                    visible: loginDropdownVisible
                }"
                :onOpen="() => loginDropdownVisible = true"
                :onClose="() => loginDropdownVisible = false"
                dropDownElementClass="nav-link mm-navigation__menu-link mm-navigation__menu-link--lowercase">
                <template slot="link">
                    <i class="icon icon-user mm-navigation__menu-list-item-icon"></i>
                    <span class="mm-navigation__menu-list-item-label">
                        Prihlasit
                    </span>
                </template>
                <AnonymousContent
                    :showCloseIcon="true"
                    :onCloseclick="() => loginDropdownVisible = false" />
            </NavigationDropdown>

            <NavigationDropdown
                v-if="authenticated"
                class="d-none d-lg-block"
                :isFilled="true"
                :isOutOfList="true"
                :isOnlyIcon="false"
                :outerState="{
                    visible: loginDropdownVisible
                }"
                :onOpen="() => loginDropdownVisible = true"
                :onClose="() => loginDropdownVisible = false"
                dropDownElementClass="nav-link mm-navigation__menu-link mm-navigation__menu-link--lowercase"
                :isWithIcon="true">
                <template slot="link">
                    <i class="icon icon-user mm-navigation__menu-list-item-icon mm-navigation__menu-list-item-icon--desktop-visible mm-navigation__menu-list-item-icon--light-circle"></i>
                    <span class="mm-navigation__menu-list-item-label">
                        &nbsp;{{userInfoText}}
                    </span>
                </template>
                <div class="dropdown__tabs">
                    <div class="dropdown__tab dropdown__tab--active">
                        moje konto
                    </div>
                    <!--<div class="dropdown__tab">moje objednávky</div>-->
                </div>
                <ProfileContent />
            </NavigationDropdown>
        </nav>
    </div>
</template>

<script>
import NavigationDropdown from "./NavigationDropdown"
import Switcher from "./LanguageSwitcher";
import AnonymousContent from '../../AccountDropdown/AnonymousContent';
import ProfileContent from '../../AccountDropdown/ProfileContent';
import NavigationSubmenuItem from './NavigationSubmenuItem';

export default {
    props: {
        menuOnHover: {
            type: Boolean,
            default: true
        },
        alwaysTop: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mobileContentWrapper: 'MobileMenu',
            loginDropdownVisible: false
        };
    },
    name: "Navigation",
    components: {
        NavigationDropdown,
        Switcher,
        AnonymousContent,
        ProfileContent,
        NavigationSubmenuItem
    },
    beforeDestroy() {
        if (this.openedMobileMenu) {
            this.closeMobileMenu();
        }
    },
    watch:{
        $route(/*to, from*/){
            this.closeMobileMenu();
        }
    },
    methods: {
        openMobileMenu() {
            this.mobileContentWrapper = 'MobileMenu';
            this.$store.dispatch('ui/openMobileMenu');
        },
        closeMobileMenu() {
            this.$store.dispatch('ui/closeMobileMenu');
        },
        togleMobileMenu() {
            if (this.openedMobileMenu && this.mobileContentWrapper === 'MobileMenu') {
                this.$store.dispatch('ui/closeMobileMenu');
            } else {
                this.mobileContentWrapper = 'MobileMenu';
                this.$store.dispatch('ui/openMobileMenu');
            }
        },
        toggleAnonymousContent() {
            if (this.openedMobileMenu && this.mobileContentWrapper === 'AnonymousContent') {
                this.$store.dispatch('ui/closeMobileMenu');
            } else {
                this.mobileContentWrapper = 'AnonymousContent';
                this.$store.dispatch('ui/openMobileMenu');
            }
        }
    },
    computed: {
        openedMobileMenu() {
            return this.$store.getters['ui/openedMobileMenu'];
        },
        userInfoText() {
            const accountDetail = this.$store.getters['auth/accountDetail'];
            return (accountDetail && accountDetail.nick) ? accountDetail.nick : 'Profile';
        },
        authenticated() {
            return this.$store.getters['auth/authenticated'];
        },
        basketItemsCount() {
            if (this.$store.getters['basket/basketItemsCount'] !== null) {
                return this.$store.getters['basket/basketItemsCount'];
            } else {
                return null;
            }
        }
    }
};
</script>
